/**
 * host-attention-row — ProviderDashboardPage "Needs Your Attention"
 * subsections (Pending booking requests, Overdue returns, Pickups
 * today or tomorrow).
 *
 * Compact row: 44×44 thumb, CUSTOMER name as the title (hosts
 * recognize "who's this from"), listing title + date range as meta,
 * No action label or status pill on the right: the section header
 * above the row already conveys the semantic ("Pickups today or
 * tomorrow", etc.), the whole row is a link, and the old "Review →"
 * label read as a leave-a-review prompt next to the customer name.
 */
import React from 'react';

import { useIntl } from '../../../util/reactIntl';
import ResponsiveImage from '../../ResponsiveImage/ResponsiveImage';
import css from '../TransactionCard.module.css';
import { formatCardDateRange } from '../formatCardDateRange';

const HostAttentionRowLayout = ({ data }) => {
  const intl = useIntl();
  const {
    startDate,
    endDate,
    firstImage,
    imageVariants,
    listingTitle,
    customerName,
    emoji,
    serviceLabel,
  } = data;

  const dateRange = formatCardDateRange(intl, startDate, endDate);

  return (
    <div className={`${css.cardRow} ${css.cardCompact}`}>
      <div className={css.cardLeftCompact}>
        <div className={css.thumb44}>
          {firstImage && imageVariants.length > 0 ? (
            <ResponsiveImage
              rootClassName={css.thumbImage}
              alt={listingTitle}
              image={firstImage}
              variants={imageVariants}
            />
          ) : (
            <span className={css.thumbEmojiCompact}>{emoji}</span>
          )}
        </div>
        <div className={css.cardBody}>
          <div className={css.cardTitleCompact}>{customerName}</div>
          <div className={css.cardMetaCompact}>
            {listingTitle}
            {dateRange ? ` · ${dateRange}` : ''}
            {serviceLabel ? ` · ${serviceLabel}` : ''}
          </div>
        </div>
      </div>
      {/* No action label: the whole card is a NamedLink to the booking,
          and "Review →" next to the CUSTOMER'S name read as "leave a
          review for them" (owner report 2026-07-08). Owner call: no text
          at all — the row is obviously clickable. */}
    </div>
  );
};

export default HostAttentionRowLayout;
